module.exports = __webpack_public_path__ + "assets/Sqrt2Detailed.fdb424abed25b7f40914db4081472f5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Sqrt2Detailed.png
// module id = 561
// module chunks = 0